import { UserLanguageTrackingService } from '@aca-new/app/shared/services/third-party-services/user-language-tracking/user-language-tracking.service';

/**
 * @description
 * Factory that initializes selected-language analytics tracking after i18n bootstrap.
 * @param {UserLanguageTrackingService} userLanguageTrackingService - Language tracking service.
 * @returns {() => void} Function that starts language tracking.
 */
export function userLanguageTrackingInitFactory(userLanguageTrackingService: UserLanguageTrackingService): () => void {
  return (): void => {
    userLanguageTrackingService.init();
  };
}
